import React from "react";
import styles from '../../css/Part13.module.css';

function PartTandC() {
  return (
    <section id="terms" className={styles.termsSection}>
        <h1>Privacy Policy</h1>
      <div className={styles.header}>
        <p className={styles.modifiedDate}>Respect for your privacy is coded into our DNA. Since we started FoneApp, we’ve aspired to build our services with a set of strong privacy principles in mind.</p>
        <p className={styles.text}>
          FoneApp provides <strong>INFORMATION</strong> services to users around the world. Our Privacy Policy helps explain our information practices.
        </p>
        <p className={styles.text}>
        When we say “FoneApp,” “our,” “we,” or “us,” we’re talking about FoneApp, ForestONE and/or MV Asia Sdn. Bhd. which is the operating company. This Privacy Policy (“Privacy Policy”) 
        applies to all mobile apps, services, features, software, and website (together, hereinafter referred to as “Services”) unless specified otherwise.
        </p>
      </div>
      
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Information We Collect
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          FoneApp receives or collects information when we operate and provide our Services, including when you install, access, or use our Services.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Information You Provide
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Your Account Information. You provide your mobile phone number to create a FoneApp account. You provide us the phone numbers in your mobile 
          address book on a regular basis, including those of both the users of our Services and your other contacts. You confirm you are authorized to 
          provide us with such numbers. You may also add other information to your account, such as a profile name and profile picture.
          </p>
          <p mb-3 className={styles.text}>
          Customer Support. You may provide us with information related to your use of our Services, including copies of your messages, and how to 
          contact you so we can provide you customer support. For example, you may send us an email with information relating to our app performance or other issues.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Automatically Collected Information
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Usage and Log Information. We collect service-related, diagnostic, and performance information. This includes information about your activity 
          (such as how you use our Services, how you interact with others using our Services, and the like), log files, and diagnostic, crash, website, and performance logs and reports.
          </p>
          <p mb-3 className={styles.text}>
          Transactional Information. If you pay for our Services, we may receive information and confirmations, such as payment receipts, including from app stores or other third parties processing your payment.
          </p>
          <p mb-3 className={styles.text}>
          Device and Connection Information. We collect device-specific information when you install, access, or use our Services. This includes information such as hardware model, operating system information, 
          browser information, IP address, mobile network information including phone number, internet cookies, and device identifiers. We collect device location information if you use our
          location features, such as when you choose to share your location with your contacts, view locations nearby or those others have shared with you, and the like, and for diagnostics 
          and troubleshooting purposes such as if you are having trouble with our app’s location features.
          </p>
          <p mb-3 className={styles.text}>
          Cookies. We use cookies to operate and provide our Services, including to provide our Services that are web-based, improve your experiences, 
          understand how our Services are being used, and customize our Services. For example, we use cookies to provide FoneApp for web and desktop 
          and other web-based services. We may also use cookies to understand which of our FAQs are most popular and to show you relevant content related 
          to our Services. Additionally, we may use cookies to remember your choices, such as your language preferences, and otherwise to customize our Services for you.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Third Party Information
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Information Others Provide About You. We receive information other people provide us, which may include information about you. For example, 
          when other users you know use our Services, they may provide your phone number from their mobile address book (just as you may provide theirs).
          </p>
          <p mb-3 className={styles.text}>
          Third-Party Providers. We work with third-party providers to help us operate, provide, improve, understand, customize, support, and market our Services. 
          For example, we work with companies to distribute our apps, provide our infrastructure, delivery, and other systems, supply map and places information, 
          process payments, help us understand how people use our Services, and market our Services. These providers may provide us information about you in certain 
          circumstances; for example, app stores may provide us reports to help us diagnose and fix service issues.
          </p>
          <p mb-3 className={styles.text}>
          Third-Party Services. We allow you to use our Services in connection with third-party services. If you use our Services with such third-party services, 
          we may receive information about you from them; for example, if you use the FoneApp share button on a news service to share a news article with your 
          FoneApp contacts, groups, or broadcast lists on our Services, or if you choose to access our Services through a mobile carrier’s or device provider’s 
          promotion of our Services. Please note that when you use third-party services, their own terms and privacy policies will govern your use of those services.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        How We Use Information
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          We use all the information we have to help us operate, provide, improve, understand, customize, support, and market our Services.
          </p>
          <p mb-3 className={styles.text}>
          Our Services. We operate and provide our Services, including providing customer support, and improving, fixing, and customizing our Services. 
          We understand how people use our Services, and analyze and use the information we have to evaluate and improve our Services, research, develop, 
          and test new services and features, and conduct troubleshooting activities. We also use your information to respond to you when you contact us. 
          We use cookies to operate, provide, improve, understand, and customize our Services.
          </p>
          <p mb-3 className={styles.text}>
          Safety and Security. We verify accounts and activity, and promote safety and security on and off our Services, such as by investigating suspicious 
          activity or violations of our Terms, and to ensure our Services are being used legally.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Information You And We Share
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          You share your information as you use our Services, and we share your information to help us operate, provide, improve, understand, customize, support, and market our Services.
          </p>
          <p mb-3 className={styles.text}>
          Account Information. Your phone number, profile name and photo may be available to anyone who uses our Services, although you can configure your Services settings to manage certain information available to other users.
          </p>
          <p mb-3 className={styles.text}>
          Third-Party Service Providers, Agents and Strategic Partners. We work with third-party Service Providers, Agents and Strategic Partners to help us operate, provide, improve, understand, customize, support, and market our Services. 
          When we share information with third-party providers, we require them to use your information in accordance with our instructions and terms or with express permission from you.
          </p>
          <p mb-3 className={styles.text}>
          Third-Party Services. When you use third-party services that are integrated with our Services, they may receive information about what you share with them. If you interact with a third-party service linked through our Services, you may 
          be providing information directly to such third parties. Please note that when you use third-party services, their own terms and privacy policies will govern your use of those services.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Retention Of Your Information
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          We will only retain your personal data and information for as long as we deem necessary to fulfil the purpose(s) for which it was collected for or to comply with any 
          legal requirements, regulatory requirements and internal requirements. Subsequently, we will destroy or permanently delete your personal data from our database, 
          once the duration of retention of such information is no longer required by law.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Affiliate Companies
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          We are part of the ForestONE eco-system and family of companies. FoneApp receives information from, and shares information with, this eco-system and family of companies. 
          We may use the information we receive from them, and they may use the information we share with them, to help operate, provide, improve, understand, customize, support, 
          and market our Services and their offerings. This includes helping improve infrastructure and delivery systems, understanding how our Services or theirs are used, securing 
          systems, and fighting spam, abuse, or infringement activities. ForestONE and the other companies in the ForestONE eco-system and family also may use information from us to 
          improve your experiences within their services such as making product suggestions and showing relevant offers and ads.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Assignment, Change Of Control, And Transfer
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          All of our rights and obligations under our Privacy Policy are freely assignable by us to any of our affiliates, in connection with a merger, acquisition, restructuring, 
          or sale of assets, or by operation of law or otherwise, and we may transfer your information to any of our affiliates, successor entities, or new owner.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Managing Your Information
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          If there are any changes to your personal data or if you believe that the personal data we have about you is inaccurate, incomplete, misleading or not up-to-date, 
          please contact us so that we may take steps to update your personal data.
          </p>
          <p mb-3 className={styles.text}>
          You have the right to access your personal data. If you would like to request access to your personal data, please contact us. Please note that depending on the information 
          requested, we may charge a small fee to retrieve that information for you. We may also take steps to verify your identity before fulfilling your request for access to your personal data.
          </p>
          <p mb-3 className={styles.text}>
          Deleting Your FoneApp Account <br/>
          You have the option to delete your FoneApp account at any time, even if it involves revoking your consent for the use of your information. 
          Upon deleting your FoneApp account, both your information and credit will be instantly removed from our servers, and they will not be refunded to the user.
          </p>
          <p mb-3 className={styles.text}>
          It's important to note that if you choose to remove our services from your device, your information will not be retained by us. We prioritize the prompt 
          and secure deletion of user data to ensure your privacy and data protection.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Law And Protection
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          We may collect, use, preserve, and share your information if we belief that it is reasonably necessary to: (a) respond pursuant to applicable law or regulations, 
          to legal process, or to government requests; (b) enforce our Terms and any other applicable terms and policies, including for investigations of potential violations; 
          (c) detect, investigate, prevent, and address fraud and other illegal activity, security, or technical issues; or (d) protect the rights, property, and safety of our 
          users, FoneApp, the ForestONE eco-system and family of companies, or others.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Our Global Operations
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          You agree to our information practices, including the collection, use, processing, and sharing of your information as described in this Privacy Policy, 
          as well as the transfer and processing of your information in Malaysia and other countries globally where we have or use facilities, service providers, 
          or partners, regardless of where you use our Services. You acknowledge that the laws, regulations, and standards of the country in which your information 
          is stored or processed may be different from those of your own country.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Updates To Our Policy
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          We may amend or update our Privacy Policy. All latest updated versions shall be shown in the “Last Modified” date at the top of this Privacy Policy. 
          Your continued use of our Services confirms your acceptance of our Privacy Policy, as amended. If you do not agree to our Privacy Policy, as amended, 
          you must stop using our Services. Please review our Privacy Policy from time to time.
          </p>
        </div>
      </div>

      {/* Repeat for other sections */}
    </section>
  );
}

export default PartTandC;
